import { type HTMLAttributes, type ReactNode } from 'react'
import { observer } from 'mobx-react-lite'
import { Avatar, Icon } from 'shared/ui'
import { type EnrollmentFilters } from 'widgets/ContactEnrollment'

import { ListItemPreview } from './ListItem'

export type IEnrollmentListPreviewProps = {
  filters: EnrollmentFilters
  previewPlaceholder?: ReactNode
  maxRenderCount?: number
}

export const EnrollmentPreview = observer(
  ({
    filters,
    maxRenderCount,
  }: Pick<IEnrollmentListPreviewProps, 'filters' | 'maxRenderCount'> &
    HTMLAttributes<HTMLDivElement>) => {
    const { allWithCount } = filters

    const items = [
      ...allWithCount.filters.map(({ item, count }, index) => (
        <ListItemPreview
          key={item.id}
          icon={<Icon icon='filter' />}
          name={`Filter ${index + 1}`}
          count={count}
        />
      )),
      ...allWithCount.tags.map(({ item, count }) => (
        <ListItemPreview key={item.id} name={item.label || `${item.id}`} count={count} />
      )),
      ...allWithCount.segments.map(({ item, count }) => (
        <ListItemPreview
          key={item.id}
          icon={<Icon icon='segment' />}
          name={item.name}
          count={count}
        />
      )),
      ...allWithCount.contacts.map(({ item, count }) => (
        <ListItemPreview
          key={item.id}
          icon={<Avatar info={item.avatarInfo} size={16} />}
          name={item.name}
          count={count}
        />
      )),
    ]

    const visibleItems = maxRenderCount ? items.slice(0, maxRenderCount) : items
    const invisibleItems = maxRenderCount ? items.slice(maxRenderCount) : []

    return (
      <>
        {visibleItems}
        {!!invisibleItems.length && <ListItemPreview name={`+${invisibleItems.length}`} />}
      </>
    )
  }
)
